export default {
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_FULFILLMENT_VIEW": "APP_FULFILLMENT_VIEW",
  "APP_LEGACY_FULFILLMENT_VIEW": "APP_LEGACY_FULFILLMENT_VIEW"
} 